import { useRef } from "react"
import { Box } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"

import { CustomTab, LeftIcon, RightIcon, theme } from "./Atom"
import { useSelector } from "react-redux"

export default function MetricGoalsTabs(props: any) {
  const { fetchGoalsByBucket } = props

  const tabsRef = useRef<any>(null)

  const handleChange = async (tab: any, newValue: number) => {
    fetchGoalsByBucket(tab?.metric_bucket_id, newValue)
  }

  const selectedMetricGoalsTab = useSelector((state: any) => {
    return state.metric.selectedMetricGoalsTab
  })

  const metricGoalsTabs = useSelector((state: any) => {
    return state.metric.metricGoalsTabs
  })

  const loading = useSelector((state: any) => {
    return state.app.loading
  })

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: "100%", sm: "100%", xl: "100%", md: "100%" },
          bgcolor: "#3C77EF",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
        }}
      >
        <Tabs
          ref={tabsRef}
          scrollButtons="auto"
          ScrollButtonComponent={(props) => {
            if (props.direction === "left") {
              return (
                <IconButton
                  size="small"
                  style={{ right: 36 }}
                  {...props}
                  disableRipple={true}
                >
                  <LeftIcon disabled={props.disabled} />
                </IconButton>
              )
            } else if (props.direction === "right") {
              return (
                <IconButton
                  size="small"
                  style={{ right: 0 }}
                  {...props}
                  disableRipple={true}
                >
                  <RightIcon disabled={props.disabled} />
                </IconButton>
              )
            } else {
              return null
            }
          }}
          value={selectedMetricGoalsTab?.index || 0}
          onChange={handleChange}
          variant="scrollable"
          aria-label="visible arrows tabs example"
          sx={{
            color: "primary.main",
            position: "relative",
            height: 56,
            paddingRight: 13,
            [`& .${tabsClasses.scrollButtons}`]: {
              position: "absolute",
              "&.Mui-disabled": { opacity: 0.9 },
            },
          }}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
        >
          {metricGoalsTabs.map((tab: any, index: any) => (
            <CustomTab
              key={tab?.metric_bucket_id}
              label={tab?.metric_bucket}
              onClick={() => handleChange(tab, index)}
              disabled={loading}
              style={{
                backgroundColor:
                  selectedMetricGoalsTab?.index === index
                    ? "#ffffff"
                    : "#1c56ce",
                color:
                  selectedMetricGoalsTab?.index === index ? "black" : "white",
                marginLeft: index === 0 ? "8px" : "0",
                fontSize:
                  selectedMetricGoalsTab?.index === index ? "16px" : "16px",
                fontWeight:
                  selectedMetricGoalsTab?.index === index ? "600" : "400",
                width: "fit-content",
                textTransform: "capitalize",
              }}
            />
          ))}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
}
